module.exports = __webpack_public_path__ + "img/master-card.fc81b4ea.png";